import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import CarruselSecundario from "../../proyectoeducativo/nivelsecundario/carruselSecundario";
import OrientacionAccordion from "../../proyectoeducativo/nivelsecundario/orientacionAccordion";
import MenuInteremedioNiveles from "../menuInteremedioNiveles";
import "../nivelesPages.css";

function Homesecundario() {
  return (
    <div className="levels-page">
      <CarruselSecundario />
      <div className="levels-menu-shell">
        <MenuInteremedioNiveles />
      </div>

      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="levels-text-card p-4" id="texto-secundario">
              <Card.Body>
                <h2 className="text-white text-center mb-4 fw-bold" style={{ letterSpacing: "1px" }}>
                  Nivel Secundario
                </h2>

                <p className="lead text-white fs-5 mb-4" style={{ lineHeight: "1.8" }}>
                  El Colegio Secundario Santo Tomás, incorporado a la enseñanza oficial de la Provincia de La Pampa,
                  brinda una formación integral a los estudiantes, que comprende saberes académicos, vinculares y
                  formación en valores. Este nivel tiene una duración de seis años, divididos en los siguientes ciclos:
                  Ciclo Básico Común, que contempla 1°, 2° y 3° año y Ciclo Orientado, que comprende 4°, 5° y 6° año.
                </p>

                <p className="lead text-white fs-5 mb-4" style={{ lineHeight: "1.8" }}>
                  El Ciclo Básico tiene como propósito fortalecer y consolidar los aprendizajes de la formación general,
                  acompañar la transición de los estudiantes en su pasaje del nivel primario a la educación secundaria y,
                  luego al Ciclo Orientado. Asimismo, pretende promover su formación en la adquisición de los saberes
                  para el desarrollo de una ciudadanía crítica y el desempeño como sujetos conscientes de sus derechos
                  y de sus obligaciones.
                </p>

                <p className="lead text-white fs-5 mb-4" style={{ lineHeight: "1.8" }}>
                  Por su parte, la Orientación garantizará que los estudiantes se apropien de saberes específicos
                  relativos a los campos del conocimiento. Además, prepara para la participación ciudadana, los
                  estudios superiores y para el mundo del trabajo.
                </p>

                <p className="lead text-white fs-5 mb-4" style={{ lineHeight: "1.8" }}>
                  En nuestra Institución, contamos con dos divisiones para el Ciclo Básico y las Orientaciones disponibles
                  son Lenguas y Ciencias Sociales y Humanidades. Para realizar la elección, se implementan los procedimientos
                  establecidos por la normativa ministerial vigente al respecto, junto a los requisitos institucionales
                  enmarcados en los Acuerdos escolares de convivencia.
                </p>

                <p className="text-white fs-5 mb-0" style={{ lineHeight: "1.8" }}>
                  Las materias que conforman la caja curricular corresponden a las contempladas por normativa ministerial
                  para el Ciclo Básico y para el Ciclo Orientado Lenguas y Ciencias Sociales y Humanidades, respectivamente.
                  Además, se incorporan por definición institucional los espacios de Formación Religiosa Católica, en el
                  Ciclo Básico y Teología, en el Ciclo Orientado, así como también, la continuidad del espacio de Tutoría
                  en este ciclo.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <OrientacionAccordion />
    </div>
  );
}

export default Homesecundario;
